var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 0C2.23851 0 0 2.33179 0 5.20819V19.7911C0 22.6675 2.23851 24.9993 4.99984 24.9993H12.9996C15.7609 24.9993 17.9994 22.6675 17.9994 19.7911V18.7495C17.9994 18.1742 17.5517 17.7078 16.9995 17.7078C16.4472 17.7078 15.9995 18.1742 15.9995 18.7495V19.7911C15.9995 21.517 14.6564 22.916 12.9996 22.916H4.99984C3.34304 22.916 1.99994 21.517 1.99994 19.7911V5.20819C1.99994 3.48235 3.34304 2.08328 4.99984 2.08328H12.9996C14.6564 2.08328 15.9995 3.48235 15.9995 5.20819V6.24983C15.9995 6.82512 16.4472 7.29147 16.9995 7.29147C17.5517 7.29147 17.9994 6.82512 17.9994 6.24983V5.20819C17.9994 2.33179 15.7609 0 12.9996 0H4.99984Z",
    fill: "#1BA397"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2926 8.63808C19.9022 9.04484 19.9022 9.7044 20.2926 10.1112L21.5855 11.4579H9.99997C9.44779 11.4579 9 11.9242 9 12.4995C9 13.0748 9.44779 13.5412 9.99997 13.5412H21.5855L20.2926 14.8879C19.9022 15.2947 19.9022 15.9542 20.2926 16.361C20.6831 16.7677 21.3163 16.7677 21.7068 16.361L24.7067 13.2361C24.8033 13.1355 24.8761 13.0193 24.9249 12.8954C24.97 12.781 24.9962 12.6564 24.9993 12.5259C24.9995 12.5171 24.9996 12.5083 24.9996 12.4995C24.9996 12.4829 24.9992 12.4662 24.9985 12.4495C24.987 12.1999 24.8898 11.9537 24.7067 11.763L21.7068 8.63808C21.3163 8.23132 20.6831 8.23132 20.2926 8.63808Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenLogout);
export default __webpack_public_path__ + "static/media/venLogout.2e4349f3364607a5347ae6b7c178e49f.svg";
export { ForwardRef as ReactComponent };